import {
  IFormDocument,
  IControl,
} from 'app/services/api5-service/api.interface';

import { ISPFormState } from 'common/dynamic-form/model';
import { DocHelper } from 'utils/dochelper';

import { ListStubMessages, ListStubData } from '../model';

/**
 * Get path for image for list stub
 *
 * @param doc
 */
function getIconUrlForStub(doc: IFormDocument): string {
  // @WARN now BE don't send which image need to display icon for stub
  const nameIconForEmptyList = 'empty-list';
  return `${doc.$host}${doc.$theme}assets/icons/${nameIconForEmptyList}.svg`;
}

/**
 * Get messages for list stub
 *
 * @param listName
 * @param doc
 */
export function getMessagesForStub(
  listName: string,
  doc: IFormDocument,
): ListStubMessages | undefined {
  const clearFilter = DocHelper.getMessage(`${listName}_drop_filter`, doc);
  const title = DocHelper.getMessage(`${listName}_empty`, doc);
  if (!clearFilter || !title) {
    return;
  }

  return {
    clearFilter,
    title,
  };
}

/**
 * Is list should display stub when it's empty
 *
 * @param control
 * @param state
 */
export function isListHasStub(control: IControl, state: ISPFormState): boolean {
  const isListWithFilter = state.listService.isListWithFilter(control.$name);
  const isListHasStubMessages = Boolean(
    getMessagesForStub(control.$name, state.docSubject.value),
  );
  return isListWithFilter && isListHasStubMessages;
}

/**
 * Get data for list stub
 *
 * @param control
 * @param state
 */
export function getDataForStub(
  control: IControl,
  state: ISPFormState,
): ListStubData | undefined {
  const hasStub = isListHasStub(control, state);
  if (!hasStub) {
    return;
  }

  return {
    messages: getMessagesForStub(control.$name, state.docSubject.value)!,
    iconUrl: getIconUrlForStub(state.docSubject.value),
    isSomeFilterApplied$: state.listService.isSomeFilterApplied$(control.$name),
  };
}
